import { render, staticRenderFns } from "./AxFilesystemArchive.vue?vue&type=template&id=e287bf0c&scoped=true&"
import script from "./AxFilesystemArchive.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemArchive.vue?vue&type=script&lang=ts&"
import style0 from "./AxFilesystemArchive.vue?vue&type=style&index=0&id=e287bf0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e287bf0c",
  null
  
)

export default component.exports